import { render, staticRenderFns } from "./SubCategoryLinks.vue?vue&type=template&id=722e7968&"
import script from "./SubCategoryLinks.vue?vue&type=script&lang=js&"
export * from "./SubCategoryLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports